export default __webpack_public_path__ + "static/media/img_baseBunnyCrochet_green_p.db081cac.jpg";